<template>
  <!-- eslint-disable -->
  <div class="email-sent">
    <h1>Check Your Email</h1>
    <p>OK, we just sent you an email message. Inside that message is a link you can use to reset your password. The message sshoud show up within a few seconds. if it doesn't, check your spam or junk folder.</p>

    <p class="recap-list">
      Let's Recap:
      <ol>
        <li>Check your email, look in the spam folder if necessary.</li>
        <li>Find the message from HUB that says "HUB Password Reset."</li>
        <li>Click the link in that message.</li>
        <li>On the resulting page, create a new password. Hopefully one that you can remember!</li>
      </ol>
    </p>

    <router-link class="back-link" :to="{ name: 'login' }">Go back to sign in</router-link>
  </div>
</template>

<script>
export default {
  name: 'EmailSent',
};
</script>

<style scoped>
.email-sent {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  max-width: 45em;
  width: 100%;
  line-height: 1.6em;
  font-size: 1.1em;
}

h1, p, a {
  margin: 0;
  padding: 0;
  color: #FFF;
  font-weight: 400;
}

p {
  margin-top: 1em;
}

p.recap-list {
  box-sizing: border-box;
  margin-top: 1em;
  padding: 1.5em 1.5em 0;
}

ol {
  counter-reset: list;
}
ol li {
  list-style: none;
}
ol li:before {
  content: counter(list) ") ";
  counter-increment: list;
  margin-right: 0.5em;
}

.back-link {
  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 3em;
  border: 0 none;
  border-radius: 0.5em;
  padding: 0.5em 4em;
  background: rgba(255, 255, 255, 0.26);
  text-decoration: none;
  transition: all ease-in-out 0.1s;
}

.back-link:hover {
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.3);
  background: rgba(255, 255, 255, 0.4);
}
</style>
